class RolloverImage {
	dotIndex = 1;

	isMoused = false;

	constructor(el) {
		if (el) {
			this.el = el;
			this.dots = [...this.el.querySelectorAll('.rollover-image__dot')];
			if (this.dots.length) {
				this.observer = new IntersectionObserver(this.handleIntersection);
				this.observer.observe(this.el);

				this.el.addEventListener('mouseenter', this.handleMouseEnter);
				this.el.addEventListener('mouseleave', this.handleMouseLeave);

				this.dots.forEach((dot) => {
					dot.addEventListener('mouseenter', this.handleDotMouseEnter);
					dot.addEventListener('mouseleave', this.handleDotMouseLeave);
					dot.addEventListener('focus', this.handleDotMouseEnter);
					dot.addEventListener('blur', this.handleDotMouseLeave);
				});
			}
		}
	}

	play = (dotIndex = 0, initialDelay = 750) => {
		this.clearTimers();
		this.timeout = setTimeout(() => {
			this.dotIndex = dotIndex;
			this.setActiveDot();
			this.interval = setInterval(() => {
				if (!this.isMoused) {
					this.dotIndex = this.dotIndex === this.dots.length - 1 ? 0 : this.dotIndex + 1;
					this.setActiveDot();
				}
			}, 4000);
		}, initialDelay);
	}

	stop = () => {
		this.clearTimers();
		this.clearActiveDot();
	}

	clearTimers = () => {
		if (this.timeout) {
			clearTimeout(this.timeout);
		}

		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	setActiveDot = () => {
		if (this.dots[this.dotIndex]) {
			this.clearActiveDot();
			this.activeDot = this.dots[this.dotIndex];
			this.activeDot.classList.add('active');
		}
	}

	clearActiveDot = () => {
		if (this.activeDot) {
			this.activeDot.classList.remove('active');
		}
	}

	handleIntersection = (entries) => {
		entries.forEach((entry) => {
			if (entry.target === this.el) {
				if (entry.isIntersecting) {
					this.play();
				} else {
					this.stop();
				}
			}
		});
	}

	handleDotMouseEnter = () => {
		this.stop();
	}

	handleDotMouseLeave = (e) => {
		const { target } = e;
		this.dots.forEach((dot, index) => {
			if (dot === target) {
				const dotIndex = index + 1 >= this.dots.length - 1 ? 0 : index + 1;
				this.play(dotIndex, 2000);
			}
		});
	}

	handleMouseEnter = () => {
		this.isMoused = true;
	}

	handleMouseLeave = () => {
		this.isMoused = false;
	}
}

const rolloverImages = [...document.querySelectorAll('.rollover-image')];
if (rolloverImages.length) {
	embark.components.rolloverImages = rolloverImages.map((el) => new RolloverImage(el));
}
